import { createContext, useContext } from 'react';

export interface SchemaFormContextValue {
  renderFields: (editMode: boolean) => React.ReactNode;
  isSubmitting: boolean;
  isSubmitted: boolean;
  submitFailed: boolean;
  isDirty: boolean;
  resetForm: () => void;
  editMode: boolean;
  enableEditMode: () => void;
  disableEditMode: () => void;
}

const SchemaFormContext = createContext<SchemaFormContextValue | null>(null);

export const SchemaFormProvider = SchemaFormContext.Provider;

export function useSchemaFormSlots() {
  const ctx = useContext(SchemaFormContext);
  if (!ctx) throw new Error('useSchemaFormSlots must be used inside SchemaForm');
  return ctx;
}
